import { useRouter } from 'next/router';

import styles from '/styles/EmailCollector.module.css';

const CtaButton = ({ text }) => {
  const router = useRouter();

  return (
    <>
      <div className="relative inline-flex group">
        <div className="absolute transition-all duration-1000 opacity-70 -inset-px bg-gradient-to-r from-[#44BCFF] via-[#FF44EC] to-[#FF675E] rounded-xl blur-lg group-hover:opacity-100 group-hover:-inset-1 group-hover:duration-200" />
        <button
          className={`relative px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-gray-900 rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 ${styles.submitButton}`}
          type="submit"
          onClick={() => router.push('/ai-girls')}
        >
          {text}
        </button>
      </div>
    </>
  );
};
export default CtaButton;
